import React, { cloneElement, useMemo, Fragment } from "react";
import PropTypes from "prop-types";
import {
  TopToolbar,
  CreateButton,
  ExportButton,
  Button,
  sanitizeListRestProps,
  List,
  TextField,
  Datagrid,
  BooleanField,
  ReferenceField,
  ArrayField,
  SingleFieldList,
  ChipField,
  DateField,
  useUpdate,
  useNotify,
  useRefresh,
  useDataProvider,
} from "react-admin";
import IconEvent from "@material-ui/icons/Event";

const ApproveButton = ({ selectedIds, resource }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const dataProvider = useDataProvider();

  const approve = () => {
    dataProvider.archive(resource, { ids: selectedIds }).then((response) => {
      refresh("/" + resource);
      notify("Comment approved");
    });
  };

  return <Button label="Approve" onClick={approve} />;
};

const PostBulkActionButtons = (props) => (
  <Fragment>
    <ApproveButton label="Reset Views" {...props} />
    {/* default bulk delete action */}
  </Fragment>
);

export default (props) => (
  <List {...props} bulkActionButtons={<PostBulkActionButtons />}>
    <Datagrid rowClick="edit">
      <TextField source="id" />

      <ReferenceField
        source="product_price_list_id"
        reference="product_price_lists"
      >
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField source="product_id" reference="products">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="markup" />
      <DateField source="created_at" />
      <DateField source="updated_at" />
    </Datagrid>
  </List>
);
